/* eslint-disable no-undef */

export const passportLogout = () => {
  $.ajax({
    url: 'https://ssa.jdl.cn/exit',
    dataType: 'jsonp',
    success: (resp) => {
      const response = JSON.parse(resp);
      if (response.result === 'success') {
        window.location.replace('/login');
      }
    },
  });
};
